export default {
  methods: {
    showLoader(message = '') {
      this.$store.commit('globalStore/setLoading', { isLoading: true, message })
    },
    hideLoader() {
      this.$store.commit('globalStore/setLoading', { isLoading: false })
    },
    showAlert(alert) {
      this.$store.dispatch('globalStore/showAlert', alert)
    },
    showTip(tip) {
      this.$store.dispatch('globalStore/showTip', tip)
    },
    openModal(component, props = {}, options = {}) {
      this.$store.dispatch('globalStore/openModal', {
        component,
        props,
        ...options
      })
    },
    closeModal() {
      this.$store.dispatch('globalStore/closeModal', this.$store.state.modals.length - 1)
    }
  }
}